import { cn } from '@/lib/utils'

const paddingMap = {
  default: 'p-0',
  xs: 'p-1',
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
} as const

const orientationMap = {
  horizontal: 'flex flex-row',
  vertical: 'flex flex-col',
} as const

type ContentLayoutProps = {
  children: React.ReactNode
  padding?: keyof typeof paddingMap
  orientation?: keyof typeof orientationMap
  className?: string
  testId?: string
}

export const ContentLayout = ({
  children,
  padding = 'default',
  orientation = 'vertical',
  className,
  testId,
}: ContentLayoutProps) => {
  return (
    <div
      className={cn(
        'h-full relative overflow-x-hidden bg-white/38',
        orientationMap[orientation],
        paddingMap[padding],
        className,
      )}
      data-testid={testId}
    >
      {children}
    </div>
  )
}
